// Ported from crehana-frontend-apps: apps/crehana-frontend/src/views/CrehanaLegal/i18n/index.ts + hooks.ts (FRONT-216)
// Standalone i18n bundle (no Next.js SSP). Follows the per-view template idiom:
// `useAddI18nLocales` registers the bundle via `addResourceBundle`; `useTranslation` is the
// typed wrapper scoped to the `crehana-legal` namespace.
import {
  useTranslation as _useTranslation,
  type I18nTranslation,
} from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import { en } from './locale-en';
import { es } from './locale-es';
import { pt } from './locale-pt';
import type { TKeys } from './types';

// Single shared bundle, namespaced under `crehana-legal` (matches I18nProvider defaultTranslations).
export const legalLocales: I18nTranslation = {
  en,
  es,
  pt,
};

/**
 * Registers the legal locale bundle on the active i18n instance. Call once near the top of the
 * legal chrome layout. Idempotent (the underlying instance dedupes bundles by reference).
 */
export const useAddI18nLocales = () => {
  const { addResourceBundle } = _useTranslation();

  addResourceBundle(legalLocales);
};

/**
 * Typed `useTranslation` scoped to the legal namespace.
 *
 * `t` is widened to accept any string: the source SidebarMenu/header build dynamic keys such as
 * `${route.key}_TITLE`, so a `string` parameter keeps those call sites cast-free while the known
 * `TKeys` still document the available keys.
 */
export const useTranslation = () => {
  return _useTranslation<TKeys | (string & {})>(PAGE_KEY);
};
